import { apiClient } from '@/infrastructure/api'
import {
  ECommerceApi,
  ECommerceApiGetAvailableRestockLocationsRequest,
  ECommerceApiSearchCatalogRequest
} from '@itsrever/rever-api'
import { toCatalogItems, toRestockLocationMap } from './dto'

export const ecommerceApi = new ECommerceApi(undefined, undefined, apiClient)

async function getItemRestockLocations(
  args: ECommerceApiGetAvailableRestockLocationsRequest,
  signal?: AbortSignal
) {
  const response = await ecommerceApi.getAvailableRestockLocations(args, {
    signal
  })
  return toRestockLocationMap(response.data)
}

async function searchCatalog(
  args: ECommerceApiSearchCatalogRequest,
  signal?: AbortSignal
) {
  const response = await ecommerceApi.searchCatalog(args, { signal })
  return toCatalogItems(response.data)
}

export default { getItemRestockLocations, searchCatalog }
